import { render, staticRenderFns } from "./CompanyCorporateActions.vue?vue&type=template&id=217bddf0"
import script from "./CompanyCorporateActions.vue?vue&type=script&lang=js"
export * from "./CompanyCorporateActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CompanyCorporateActions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VueSimpleAccordion: require('/vercel/path0/components/VueSimpleAccordion.vue').default})
